import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch as useAppDispatch, useSelector as useAppSelector, TypedUseSelectorHook } from 'react-redux';

//slices
import CustomizerReducer from './customizer/CustomizerSlice';
import groupReducer from './apps/groups/GroupSlice';
import DomainReducer from './apps/domain/DomainSlice';
import OrganizationReducer from './apps/organization/OrganizationSlice';
import UserReducer from './apps/users/UserSlice';
import RolesReducer from './apps/roles/RoleSlice';
import toastReducer from './apps/toast/ToastSlice';
import ApplicationReducer from './apps/application/Application';
import PermissionReducer from './apps/permission/PermissionSlice';
import PublisherReducer from './apps/publisher/PublisherSlice';
import DeveloperReducer from './apps/developer/DeveloperSlice';
import AdminDomainReducer from './apps/admin/AdminSlice';
import AnalyticReducer from './apps/analytics/AnalyticSlice';
import ApplicationCreationSlice from './apps/applicationCreation/applicationCreationSlice';
import EntitiesSlice from './apps/entities/EntitiesSlice';
import MappingManagementSlice from './apps/mappingManagement/MappingManagementSlice';

const rootReducer = combineReducers({
  customizer: CustomizerReducer,
  group: groupReducer,
  domain: DomainReducer,
  organization: OrganizationReducer,
  role: RolesReducer,
  user: UserReducer,
  toast: toastReducer,
  application: ApplicationReducer,
  permission: PermissionReducer,
  publisher: PublisherReducer,
  devPortal: DeveloperReducer,
  admin: AdminDomainReducer,
  analytics: AnalyticReducer,
  applicationCreation: ApplicationCreationSlice,
  entities: EntitiesSlice,
  mapping: MappingManagementSlice,
});

const store = configureStore({
  reducer: rootReducer,
});

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const { dispatch } = store;
export const useDispatch = () => useAppDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<AppState> = useAppSelector;
export default store;
